<div (click)="openCreditNotes()" style="text-align:right;color: white;font-size: 12px;margin-bottom:10px;text-shadow:0 0 8px black, -1px -1px 4px black, 1px 1px 4px black;" class="credit-button fdm-link">
  <ng-container *ngIf="!fourD.domainConfig || !fourD.domainConfig['credits']">
    <div>{{ 'GENERIC.CREDIT_NOTES' | translate }}</div>
    <div>{{ 'GENERIC.POWERED_BY' | translate }}</div>
    <div>Version {{ service.vasatInstance?.app_version }}</div>
  </ng-container>
  <div *ngIf="fourD.domainConfig && fourD.domainConfig['credits']">{{ fourD?.domainConfig['credits'] }}</div>
</div>
